import request from '@/utils/request';

/**
 * 工会数据同步 API
 */

// 手动触发全量同步
export function fullSync() {
  return request({
    url: '/admin/union-sync/full',
    method: 'POST'
  });
}

// 手动触发工会基本信息同步
export function syncUnionBase() {
  return request({
    url: '/admin/union-sync/union-base',
    method: 'POST'
  });
}

// 手动触发工会用户同步
export function syncUnionUser() {
  return request({
    url: '/admin/union-sync/union-user',
    method: 'POST'
  });
}

// 分页同步工会基本信息
export function syncUnionBasePage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union-sync/union-base/page',
    method: 'POST',
    params: {
      current: params.current || 1,
      size: params.size || 100
    }
  });
}

// 分页同步工会用户
export function syncUnionUserPage() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/union-sync/union-user/page',
    method: 'POST',
    params: {
      current: params.current || 1,
      size: params.size || 100
    }
  });
}